import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';
import { MapSet } from './schemas/map-set.schema';

export function putMapSets(mapSet: Partial<MapSet>) {
  return fromFetch(
    new Request(`${fleetEnvironment.mapSetsUrl}/${mapSet.customMapsetId}`, {
      method: 'PUT',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify({
        ...mapSet,
      }),
    })
  ).pipe(ignoreData());
}
